// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/catalogs_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsCatalogsDatatable } from "./constants";
import type { AppsCatalogsDatatableParams, AppsCatalogsDatatableResult } from "./types";

export const getDataTableAppsCatalogsDatatable = reactQueryTableFetcherAdapter(
  appsCatalogsDatatable,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, sortby, sortdir, limit = 20, start = 0 }: AppsCatalogsDatatableParams
  ): Promise<AppsCatalogsDatatableResult> => {
    return fetch(
      "/apps/catalogs_datatable",
      "GET",
      {
        groupby,
        query: serializeQueryObjects(query),
        sortby,
        sortdir,
        limit,
        start,
        app_group_id: appGroupId,
      },
      { signal }
    );
  }
);
